import { useState } from "react";
import { toast } from "sonner";
import { Trash2 } from "lucide-react";
import { useApi, errMsg, ago } from "@/lib/api";

const CATS = ["missing form", "pace", "barrier", "rail", "track condition", "sectionals", "roughie not value", "other"];
const field = "bg-[#0B101D] border border-white/10 rounded-lg px-2 py-1.5 text-sm";

export const FeedbackBox = ({ m, r, picks: sel, feedback, setFeedback }) => {
  const api = useApi();
  const inSel = new Set(sel.map((p) => p.number));
  const picks = [...sel, ...(r.runners || []).filter((x) => !inSel.has(x.number)).map((x) => ({ ...x, role: "" }))];
  const [pick, setPick] = useState(picks[0] ? `${picks[0].number}|${picks[0].role}` : "");
  const [cat, setCat] = useState(CATS[0]);
  const [text, setText] = useState("");
  const id = `${m.id}-${r.number}`;
  const add = async () => {
    const [number, role] = pick.split("|");
    try {
      const f = await api("post", `/analyst/races/${m.id}/${r.number}/feedback`, { number: Number(number), role: role || null, category: cat, text: text.trim() });
      setFeedback((x) => [f, ...x]);
      setText("");
      toast.success("Feedback saved");
    } catch (e) { toast.error(errMsg(e)); }
  };
  const del = async (fid) => {
    try { await api("delete", `/analyst/feedback/${fid}`); setFeedback((x) => x.filter((f) => f.id !== fid)); } catch (e) { toast.error(errMsg(e)); }
  };
  return (
    <div className="space-y-2" data-testid={`analyst-feedback-${id}`}>
      {picks.length ? (
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-2">
          <select data-testid={`feedback-pick-${id}`} value={pick} onChange={(e) => setPick(e.target.value)} className={field}>
            {picks.map((p) => <option key={`${p.number}|${p.role}`} value={`${p.number}|${p.role}`}>{p.role ? `${p.role}: ` : ""}{p.number}. {p.horse}</option>)}
          </select>
          <select data-testid={`feedback-category-${id}`} value={cat} onChange={(e) => setCat(e.target.value)} className={field}>
            {CATS.map((c) => <option key={c} value={c}>{c}</option>)}
          </select>
          <textarea data-testid={`feedback-text-${id}`} value={text} onChange={(e) => setText(e.target.value)} rows={2} maxLength={1000} placeholder="What did it miss or get wrong?" className={`${field} sm:col-span-2`} />
          <button data-testid={`feedback-save-${id}`} onClick={add} disabled={!text.trim()} className="px-4 py-1.5 rounded-full bg-blue-600 hover:bg-blue-500 text-xs font-semibold disabled:opacity-40">Save feedback</button>
        </div>
      ) : <p className="text-xs text-slate-500">No runners to give feedback on.</p>}
      <ul className="space-y-1.5" data-testid={`feedback-list-${id}`}>
        {feedback.map((f) => (
          <li key={f.id} className="flex gap-2 items-start text-xs text-slate-300" data-testid={`feedback-item-${f.id}`}>
            <span className="shrink-0 uppercase tracking-widest text-[10px] text-blue-300 border border-blue-500/30 rounded px-1.5">{f.category}</span>
            <span className="flex-1"><b>{f.horse}</b>{f.role ? ` (${f.role})` : ""}: {f.text} <span className="text-slate-500">· {ago(f.at)}</span></span>
            <button data-testid={`feedback-delete-${f.id}`} onClick={() => del(f.id)} aria-label="Delete feedback" className="text-slate-500 hover:text-rose-300"><Trash2 className="w-3.5 h-3.5" /></button>
          </li>
        ))}
      </ul>
    </div>
  );
};
